// @flow
import { createSelector } from 'reselect';
import { getBaseUrl } from './config';
import type { GlobalState } from '../rootReducer';
import { LOCATION_CHANGE } from 'connected-react-router';

/* reducer */
const DEFAULT_STATE = {
    currentUrl: {
        pathname: '',
    },
    pastUrl: {
        pathname: '',
    },
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                currentUrl: { ...action.payload.location },
                pastUrl: { ...state.currentUrl },
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.route;

export const getCurrentUrl: GlobalState => any = createSelector(stateSelector, state => state.currentUrl || {});

export const getPastUrl: GlobalState => any = createSelector(stateSelector, state => {
    return state.pastUrl || {};
});

export const isHomePage: GlobalState => boolean = createSelector(
    getCurrentUrl,
    currentUrl => currentUrl.pathname === '/',
);

export const isServerSideRendered: GlobalState => boolean = createSelector(
    [getCurrentUrl, getPastUrl],
    (currentUrl, pastUrl) => Boolean(!pastUrl.pathname && currentUrl.pathname),
);

export const getCurrentUrlFromState: GlobalState => string = createSelector(
    [getCurrentUrl, getBaseUrl],
    (currentUrl, baseUrl) => `${baseUrl}${currentUrl.pathname}${currentUrl.search}`,
);
